import { useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import PortalLayout from '../layouts/PortalLayout';
import { SignUpFormValues, SignUpPage, SignUpPageValidationProps, SignUpValidation } from '../pages/SignUp';
import { useRuntimeConfig } from '../runtimeConfig';

type PendingData = SignUpPageValidationProps['validation'];

type LocationState = { mobilePhone?: string };

const SignUpRoute = () => {
    const [pendingData, setPendingData] = useState<PendingData | null>(null);
    const { countryCode } = useRuntimeConfig();

    const { mobilePhone: initialMobilePhone = '' } = useLocation<LocationState>().state || {};

    const initialValues = useMemo(
        (): SignUpFormValues => ({
            fullName: '',
            email: '',
            mobilePhone: { internationalCode: countryCode, number: initialMobilePhone },
            brand: { main: '' },
            password: '',
            confirmPassword: '',
            type: '',
        }),
        [initialMobilePhone, countryCode]
    );

    const onBack = useMemo(() => {
        if (pendingData?.token) {
            return () => setPendingData({ ...pendingData, token: null });
        }

        return undefined;
    }, [pendingData, setPendingData]);

    if (pendingData?.token) {
        return (
            <PortalLayout onBack={onBack} onLight>
                <SignUpValidation validation={pendingData} />
            </PortalLayout>
        );
    }

    return (
        <PortalLayout onBack={onBack} onLight>
            <SignUpPage initialValues={pendingData?.values || initialValues} next={setPendingData} />
        </PortalLayout>
    );
};

export default SignUpRoute;
